module.exports = __webpack_public_path__ + "img/auto_ask_example.d6cc2f64.png";